export enum PromptType {
    Text = "Text",
    Hint = "Hint"
}
export enum InputType {
    MC = "MC",
    Number = "Number",
    Sort = "Sort",
    Phrase = "Phrase"
}

export type Hint = { prompt:string, answer:string }

interface BaseQuestionDefinition {
    index: number
    explanation: string
    sources: string
    duration: number
    poll: boolean //true = no correct answer, false = has correct answer
    prompt: string
    inputType: InputType
    promptType: PromptType
    multiSubmit: boolean
}

interface TextQuestionDefinition extends BaseQuestionDefinition {
    promptType: PromptType.Text
}

export interface HintQuestionDefinition extends BaseQuestionDefinition {
    promptType: PromptType.Hint
    //TODO: In the future we may want to filter this too
    hints: (Hint|string)[]
}

export interface MCQuestionDefinition extends BaseQuestionDefinition {
    inputType: InputType.MC
    options: string[]
    correctIndex?: number
}

export interface NumberQuestionDefinition extends BaseQuestionDefinition {
    inputType: InputType.Number
    correctNumber?: number
    maxDifference?: number
}

export interface SortQuestionDefinition extends BaseQuestionDefinition {
    inputType: InputType.Sort
    options: string[]
    correctIndices?: number[]
}

export interface PhraseQuestionDefinition extends BaseQuestionDefinition {
    inputType: InputType.Phrase
    phrase: string
    shuffledLetters: string[]
    hintTime: number[] //index = seconds elapsed, value = hint to show
}

export type QuestionDefinition = (HintQuestionDefinition | TextQuestionDefinition) //Prompt Types
    & (MCQuestionDefinition | NumberQuestionDefinition | SortQuestionDefinition | PhraseQuestionDefinition); //Input Types
